import { gql } from '@apollo/client';

export const loginMutation = gql`
    mutation Login($initDataRaw: String!) {
        login(data: { initDataRaw: $initDataRaw }) {
            userId
            value
            role
            registrationStage
        }
    }
`;
